<div class="app-action-menu" [ngClass]="customClass" (click)="stopPropagation($event)">
  <!-- Trigger -->
  <div
    class="app-action-menu__trigger"
    [matMenuTriggerFor]="matMenu"
    (menuOpened)="menuOpened.emit()"
    (menuClosed)="menuClosed.emit()"
  >
    <!-- Custom Trigger Projected via [trigger] -->
    <ng-content select="[trigger]"></ng-content>

    <!-- Default 3-Dots Vertical Trigger Button -->
    <button
      type="button"
      *ngIf="!hasCustomTrigger"
      class="app-action-menu__trigger-btn"
      [ngClass]="[
        'app-action-menu__trigger-btn--' + triggerVariant,
        'app-action-menu__trigger-btn--' + triggerSize
      ]"
      [disabled]="disabled"
      aria-label="Actions menu"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        class="bi bi-three-dots-vertical app-action-menu__dots-icon"
      >
        <path
          d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
        />
      </svg>
    </button>
  </div>

  <!-- Menu Dropdown -->
  <mat-menu
    #matMenu="matMenu"
    [xPosition]="xPosition"
    [yPosition]="yPosition"
    [class]="'app-action-menu-panel ' + menuClass"
  >
    <div class="app-action-menu__dropdown-content" (click)="stopPropagation($event)">
      <!-- Header -->
      <p *ngIf="showHeader && headerText" class="app-action-menu__header">
        {{ headerText }}
      </p>

      <!-- Config-based Items List -->
      <ng-container *ngIf="items && items.length > 0">
        <ng-container *ngFor="let item of items">
          <app-action-menu-item
            *ngIf="!item.hidden"
            [icon]="item.icon || ''"
            [iconClass]="item.iconClass || ''"
            [variant]="item.variant || 'default'"
            [disabled]="!!item.disabled"
            [copyValue]="item.copyValue || ''"
            (clicked)="onItemClick(item, $event)"
          >
            {{ item.label }}
          </app-action-menu-item>
        </ng-container>
      </ng-container>

      <!-- Declaratively Projected Menu Items & Dividers -->
      <ng-content></ng-content>
    </div>
  </mat-menu>
</div>
